import { render, staticRenderFns } from "./snailBookNew.vue?vue&type=template&id=dd70464a&scoped=true&"
import script from "./snailBookNew.vue?vue&type=script&lang=js&"
export * from "./snailBookNew.vue?vue&type=script&lang=js&"
import style0 from "./snailBookNew.vue?vue&type=style&index=0&id=dd70464a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd70464a",
  null
  
)

export default component.exports